module["exports"] = [
  "##-###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pl/address/postcode.js
// module id = 1553
// module chunks = 0